import { useState } from 'react'

import { MINUTE, SECOND } from '../../../constants/date'
import { useSchedule } from '../../../hooks'
import { Container } from '../Container'
import { Controls, controls, radioGroup } from '../Controls'

export function UseSchedule() {
  const [args, setArgs] = useState(() =>
    controls() //
      .add(
        radioGroup('timeout', 15 * SECOND, {
          options: [SECOND, 15 * SECOND, MINUTE],
        })
      )
  )

  const [date, setDate] = useState(null)

  useSchedule(args.getValues().timeout, () => setDate(new Date()))

  return (
    <>
      <Container label='useSchedule(timeout, callback)'>
        <pre>{JSON.stringify(date, null, 4)}</pre>
      </Container>

      <Controls value={args} onChange={setArgs} />
    </>
  )
}
